import * as React from 'react'
import { observer } from 'mobx-react'
import {
  Dialog,
  DialogButton,
  DialogButtonGroup,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components/Dialog'
import { Form, TextAreaContainer } from 'components/inputs'
import AddJobNoteDialogViewModel from './AddJobNoteDialogViewModel'
import styles from './AddJobNoteDialog.sass'

interface Props {
  vm: AddJobNoteDialogViewModel
}

// Show remaining chars when approaching the limit.
const COUNTER_THRESHOLD = 200

export default observer(function AddJobNoteDialog({ vm }: Props) {
  return (
    <Dialog showing={vm.showing} onClose={!vm.sendNote.pending && vm.close}>
      <Form onSubmit={() => vm.sendNote()}>
        <DialogHeader>
          <DialogTitle>Add Job Note</DialogTitle>
          <DialogDescription>
            Capture context, updates, or decisions for this job.
          </DialogDescription>
        </DialogHeader>
        <DialogContent>
          <TextAreaContainer
            autoFocus
            data-private
            rows={5}
            label="Note"
            help="Add any relevant details or context. Notes can be seen by anyone with access to the job, minus the client."
            model={vm}
            field="composerText"
            disabled={vm.sendNote.pending}
            maxLength={vm.MAX_NOTE_LENGTH}
            data-test="add-job-note-input"
          />
          {vm.noteCharsRemaining <= COUNTER_THRESHOLD && (
            <span className={styles.charCount}>
              {vm.noteCharsRemaining} characters remaining
            </span>
          )}
        </DialogContent>
        <DialogFooter bordered>
          <DialogButtonGroup>
            <DialogButton
              disabled={vm.sendNote.pending}
              onClick={vm.close}
              type="default"
            >
              Cancel
            </DialogButton>
            <DialogButton
              submit
              loading={vm.sendNote.pending}
              disabled={!vm.canSend}
              type="primary"
              dataTest="add-job-note-confirm"
            >
              Publish Note
            </DialogButton>
          </DialogButtonGroup>
        </DialogFooter>
      </Form>
    </Dialog>
  )
})
